import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import {
  NotificationService,
  NOTIFICATION_TYPE_INFO,
  NOTIFICATION_TYPE_SUCCESS,
  NOTIFICATION_DURATIONS,
} from 'ui-components/services/notification-service';

import Globals from '../../../../../store/global-selectors';

import { downloadSamplePackingSlip } from '../../api';
import messages from '../../messages';
import { removeDownloadCookie } from './cookie-cleanup';

const startingDownload = () => {
  return NotificationService.showNotification({
    title: '',
    notificationType: NOTIFICATION_TYPE_INFO,
    content: <FormattedMessage {...messages.startingDownload} />,
    duration: NOTIFICATION_DURATIONS.SHORT,
  });
};

const finishedDownload = () => {
  return NotificationService.showNotification({
    title: '',
    notificationType: NOTIFICATION_TYPE_SUCCESS,
    content: <FormattedMessage {...messages.finishedDownload} />,
    duration: NOTIFICATION_DURATIONS.MEDIUM,
  });
};

const DownloadSample = ({ children }) => {
  const stores = useSelector(Globals.selectSellerStores);
  const onDownloadClick = (storeGuid, template) => {
    startingDownload();
    downloadSamplePackingSlip(storeGuid, template).then(finishedDownload);
  };

  useEffect(() => {
    return () => removeDownloadCookie();
  }, []);

  return children({ stores, onDownloadClick });
};

DownloadSample.propTypes = {
  children: PropTypes.func.isRequired,
};

export default DownloadSample;
